export const throttle = (context, func, limit) => {
    let lastFunc = null;
    let lastRan = null;
    return (...args) => {
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        }
        else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(function () {
                if (Date.now() - lastRan >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
};
//# sourceMappingURL=throttle.js.map